<template>
  <v-form v-model="valid" ref="mainForm">
    <adresse-personnelle :carteAffaire="sas.adressePersonnelle" two-columns></adresse-personnelle>

    <opq-text-field
      code="cellulaire-perso"
      v-model="sas.adressePersonnelle.cellulaire"
      is-phone-number
      :code-pays="codePays(sas.adressePersonnelle.pays)"
      :live="liveSasCartesAffaires(2934)"
      optional
    ></opq-text-field>
    <opq-case
      code="adresse-perso-correspondance"
      v-model="sas.adressePersonnelle.adresseDeCorrespondance"
      :live="liveSasCartesAffaires(2944)"
      optional
      ref="adresseDeCorrespondance"
      @eudo-updated="adresseDeCorrespondanceUpdated"
    ></opq-case>
  </v-form>
</template>

<script>
import CataloguesHelper from "@/mixins/CataloguesHelpers"
import AdressePersonnelle from "@/components/FormParts/AdressePersonnelle"
import FormSimple from "@/mixins/FormSimple"
import { bus } from "@/plugins/bus"
export default {
  mixins: [CataloguesHelper, FormSimple],
  components: {
    AdressePersonnelle
  },
  props: {
    sas: { type: Object }
  },

  methods: {
    liveSasInscriptionTableauRegistre(cle) {
      return { endpoint: "sas-inscriptions-tableau-registre", cle: cle, fileId: this.sas.sasInscriptionAuTableauRegistre.id }
    },
    liveSasCartesAffaires(cle) {
      return { endpoint: "sas-cartes-affaires", cle: cle, fileId: this.sas.adressePersonnelle.id }
    },
    adresseProSelectedAsCorrespondance() {
      this.$refs["adresseDeCorrespondance"].setValue(false)
    },
    adresseDeCorrespondanceUpdated(event) {
      if (event) {
        bus.$emit("adresse-perso-selected-as-correspondance")
      }
    }
  },

  created() {
    bus.$on("adresse-pro-selected-as-correspondance", this.adresseProSelectedAsCorrespondance)
  }
}
</script>

<style>
</style>